<template>
  <div class="ty-main">
<!--    <div class="tip">-->
<!--        <el-button class="fr mb20" type="primary" @click="addStaff">添加员工</el-button>-->
<!--        <el-button class="fr mb20" type="primary" style="margin-right: 28px;" @click="$router.push({-->
<!--                  path: '/setting/regulation'-->
<!--                })">添加AD账号</el-button>-->
<!--    </div>-->

    <div class="ty-cont">
      <el-form :inline="true" class="query-form" onsubmit="return false;">
        <el-form-item label="姓名:">
          <el-input
            v-model="keyword1"
            placeholder="请输入员工姓名"
            clearable
            style="width: 202px;"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button class="dsfdi" type="primary" @click="onSearch">查询</el-button>
        </el-form-item>
        <div class="fr hidden" v-auth="['wordAdd']">
          <el-button class="dsfdi" type="primary" @click="$router.push({
                  path: '/setting/regulation'
                })">添加</el-button>
        </div>
      </el-form>
    </div>
    <div class="ty-content white">
      <el-table :data="tableData" style="width: 100%" id="table">
        <el-table-column label="姓名" fixed width="200">
           <template slot-scope="scope">
            <div  v-if="scope.row.name.length > 0">
              <el-popover
                v-if="scope.row.name.length > 10"
                placement="top-start"
                popper-class="popperBox"
                trigger="hover">
                <div>{{scope.row.name}}
                <!--  <span class="tag" v-if="scope.row.new_user_session_status === -1">存档关闭</span>
                  <span class="tag01" v-if="scope.row.new_user_session_status === 1">存档</span>
                  <span class="tag" v-if="scope.row.new_user_status === -1">离职</span>-->
                </div>
                <span slot="reference" style="color: #303133;">{{scope.row.name | ellipsis}}
                <!--  <span class="tag" v-if="scope.row.new_user_session_status === -1">存档关闭</span>
                  <span class="tag01" v-if="scope.row.new_user_session_status === 1">存档</span>
                  <span class="tag" v-if="scope.row.new_user_status === -1">离职</span>-->
                </span>
              </el-popover>
              <span v-else>{{scope.row.name}}</span>
              </div>
              <span v-else>-</span>
            </template>
        </el-table-column>
        <el-table-column prop="department_name" label="部门" width="394">
          <template slot-scope="scope">
            <div  v-if="scope.row.department_name.length > 0">
              <el-popover
                v-if="scope.row.department_name.length > 30"
                placement="top-start"
                popper-class="popperBox"
                trigger="hover">
                <div>{{scope.row.department_name}}</div>
                <span slot="reference" style="color: #303133;">{{scope.row.department_name | ellipsissss}}</span>
              </el-popover>
              <span v-else>{{scope.row.department_name}}</span>
            </div>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column prop="ad_email" label="AD邮箱" width="394">
          <template slot-scope="scope">
            <div  v-if="scope.row.ad_email.length > 0">
              <el-popover
                v-if="scope.row.ad_email.length > 30"
                placement="top-start"
                popper-class="popperBox"
                trigger="hover">
                <div>{{scope.row.ad_email}}</div>
                <span slot="reference" style="color: #303133;">{{scope.row.ad_email | ellipsissss}}</span>
              </el-popover>
              <span v-else>{{scope.row.ad_email}}</span>
            </div>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column prop="ad_email" label="企业微信邮箱" width="394">
          <template slot-scope="scope">
            <div  v-if="scope.row.qy_wx_email.length > 0">
              <el-popover
                v-if="scope.row.qy_wx_email.length > 30"
                placement="top-start"
                popper-class="popperBox"
                trigger="hover">
                <div>{{scope.row.qy_wx_email}}</div>
                <span slot="reference" style="color: #303133;">{{scope.row.qy_wx_email | ellipsissss}}</span>
              </el-popover>
              <span v-else>{{scope.row.qy_wx_email}}</span>
            </div>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column label="是否开启企微扫码登录" width="434">
        <template slot-scope="scope">
          <div v-if="scope.row.qy_wx_status.toString().length > 0">
            <el-popover
              v-if="scope.row.qy_wx_status.toString().length > 30"
              placement="top-start"
              popper-class="popperBox"
              trigger="hover">
              <div>{{scope.row.qy_wx_status.toString()}}</div>
              <span slot="reference" style="color: #303133;">{{scope.row.qy_wx_status.toString() | ellipsissss}}</span>
            </el-popover>
            <span v-else>{{scope.row.qy_wx_status.toString()}}</span>
          </div>
          <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column label="角色" width="434">
          <template slot-scope="scope">
            <div v-if="scope.row.role_name.toString().length > 0">
              <el-popover
                v-if="scope.row.role_name.toString().length > 30"
                placement="top-start"
                popper-class="popperBox"
                trigger="hover">
                <div>{{scope.row.role_name.toString()}}</div>
                <span slot="reference" style="color: #303133;">{{scope.row.role_name.toString() | ellipsissss}}</span>
              </el-popover>
              <span v-else>{{scope.row.role_name.toString()}}</span>
            </div>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column label="更新时间" min-width="180">
          <template slot-scope="scope">
            <div class="okm">{{scope.row.time ? scope.row.time : '-'}}</div>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="180" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" @click="setRole(scope.row)" v-auth="['userEdit']" class="hidden"
              >设置角色</el-button
            >
            <el-divider direction="vertical"></el-divider>
            <el-button
              type="text"
              @click="handleDelete(scope.row.user_id)"
              class="hidden"
              v-auth="['userDel']"
              >删除</el-button
            >
          </template>
        </el-table-column>
        <template #empty>
          <el-empty v-loading="loading"></el-empty>
        </template>
      </el-table>
      <div class="toolbar">
        <div></div>
        <el-pagination
          background
          @current-change="currentChange"
          :current-page="currentPage"
          :page-size="pagesize"
          layout="total, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </div>

    <el-dialog title="设置角色"
    :show-close="false"
    :close-on-click-modal="false"
    :visible.sync="isEditDialog"
    :before-close="clearRoleInfo"
    width="622px">
    <div style="margin-bottom: -16px;margin-left: 4px;">
      <el-form
        class="dialog-form"
        :model="roleInfo"
        :rules="rules"
        label-width="120px"
        ref="roleInfo"
      >
        <el-checkbox-group v-model="roleInfo.role">
          <template v-for="item in roles">
            <el-checkbox :label="item.role_id" :key="item.role_id" @change="getCode(item)" name="role">{{
              item.role_name
            }}</el-checkbox>
          </template>
        </el-checkbox-group>
      </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="info" plain @click="close">取消</el-button>
        <el-button style="width: 72px;" type="primary" @click="getUserRole">确定</el-button>
      </div>
    </el-dialog>
    <department
      :isShow="isDepartmentDialog"
      @check-user="checkUser"
      :isMultiple="false"
      :checkeds="checkedEmployees"
      v-if="isDepartmentDialog"
      :title="title"
    ></department>
  </div>
</template>
<script>
import { departmentCycle } from '@/utils/util'
import Department from '../../components/department'
export default {
  components: {
    Department
  },
  data() {
    return {
      keyword1: '',
      currentPage: 1,
      pagesize: 10,
      total: 0,
      cur: false,
      searchName: '',
      sendName: [],
      loading: false,
      sendOutName: [],
      tableData: [],
      roles: [],
      roleInfo: {
        role: []
      },
      t: [],
      naks: [],
      isDepartmentDialog: false,
      userId: '',
      isEditDialog: false,
      code: [],
      r: [],
      rules: {
        role: [
          {
            type: 'array',
            required: true,
            message: '请至少选择一所属角色',
            trigger: 'change'
          }
        ]
      },
      department: [],
      checkedEmployees: [],
      time: '',
      title: true
    }
  },
  mounted() {
    this.getList()
    // this.getDepartment()
    this.getRole()
  },
  methods: {
    getList() {
      this.loading = true
      this.$api
        .get('/api/system/manage/staff', {
          type: 1,
          user_name: this.keyword1,
          page: this.currentPage
        })
        .then(res => {
          this.total = res.total
          console.log(res)
          const tableData = res.data
          tableData.forEach(v => {
            // 部门转换
            v.departmentList = []
            const departmentList = v.departmentList
            if (v.department) {
              const list = v.department.split('/')
              list.forEach(v => {
                if (v) {
                  departmentList.push(departmentCycle(this.department, v))
                }
              })
            }
          })
          this.tableData = tableData
          this.loading = false
        })
    },
    // getDepartment() {
    //   this.$api.get('/api/get/department').then(res => {
    //     const red = res
    //     let label = ''
    //     let departmentId = ''
    //     const arr = []
    //     for (let i = 0; i < red.length; i++) {
    //       if (red[i].parent_id === 0) {
    //         label = red[i].name
    //         departmentId = parseInt(red[i].department_id)
    //       }
    //       if (departmentId && red[i].parent_id === departmentId) {
    //         const obj = {
    //           child: [],
    //           label: red[i].name,
    //           value: red[i].department_id
    //         }
    //         arr.push(obj)
    //       }
    //     }

    //     for (const item of arr) {
    //       item.child = this.arr(red, item.value)
    //       for (const v of item.child) {
    //         v.child = this.arr(red, v.value)
    //         for (const s of v.child) {
    //           s.child = this.arr(red, s.value)
    //           for (const s1 of s.child) {
    //             s1.child = this.arr(red, s1.value)
    //             for (const s2 of s1.child) {
    //               s2.child = this.arr(red, s2.value)
    //               for (const s3 of s2.child) {
    //                 s3.child = this.arr(red, s3.value)
    //               }
    //             }
    //           }
    //         }
    //       }
    //     }
    //     this.department = [
    //       {
    //         label: label,
    //         value: departmentId,
    //         child: arr
    //       }
    //     ]
    //     this.getList()
    //   })
    // },
    arr(arr, departmentId) {
      const arr2 = []
      for (let i = 0; i < arr.length; i++) {
        if (parseInt(departmentId) === arr[i].parent_id) {
          const obj = {
            child: [],
            label: arr[i].name,
            value: arr[i].department_id
          }
          arr2.push(obj)
        }
      }
      return arr2
    },
    // cycle(department, id) {
    //   const dId = String(id)
    //   let result = ''
    //   department.forEach(v => {
    //     if (dId === v.value) {
    //       result = v.label
    //       return false
    //     } else {
    //       if (v.child && result === '') {
    //         result = this.cycle(v.child, dId)
    //       } else {
    //         return false
    //       }
    //     }
    //   })
    //   return result
    // },
    getRole() {
      this.$api
        .get('api/system/role/index', {
          limit: 1000
        })
        .then(res => {
          this.roles = res.data
          this.naks.forEach(k => {
            this.roles.forEach(p => {
              if (k === p.role_name) {
                this.roleInfo.role.push(p.role_id)
              }
            })
          })
        })
    },
    setRole(row) {
      this.naks = row.role_name
      this.time = row.time
      this.isEditDialog = true
      this.t = row.name
      this.getRole()
      this.userId = row.user_id
      this.naks.forEach(k => {
        this.roles.forEach(h => {
          if (k === h.role_name) {
            this.r.push(h.code)
          }
        })
      })
    },
    getCode(item) {
      if (this.r.indexOf(item.code) > -1) {
         this.r.splice(this.r.indexOf(item.code), 1)
      } else {
          this.r.push(item.code)
      }
    },
    editRole(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.$api
            .get('/api/setting/user/role', {
              role_id: this.roleInfo.role,
              user_id: this.userId
            })
            .then(res => {
              this.getList()
              this.isEditDialog = false
              this.$message({
                message: '添加角色成功！',
                type: 'success'
              })
            })
        }
      })
    },
    getUserRole() {
      if (this.roleInfo.role.length === 0) {
        this.$message.warning('至少设置一个角色，若不设置角色请删除成员!')
        return false
      }
      if (this.r.length < 2) {
        var code = ''
        code = this.code[0]
      }
      this.$api.post('/api/system/bind/manage/role', {
        user_id: this.userId,
        role_code: code || this.r,
        lastUpdateTime: this.time
      })
      .then(res => {
         this.isEditDialog = false
         code = ''
         this.r = []
         this.roleInfo.role = []
         this.time = ''
         this.getList()
      })
    },
    close() {
      this.code = ''
      this.r = []
      this.isEditDialog = false
      this.roleInfo.role = []
    },
    currentChange(val) {
      this.tableData = []
      this.currentPage = val
      this.getList()
    },
    onSearch() {
      this.currentPage = 1
      this.getList()
    },
    openDialog() {
      this.isEditDialog = true
    },
    handleDelete(id) {
      this.$confirm('此操作将删除该员工所有权限，是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        showClose: false,
        closeOnClickModal: false
      })
        .then(() => {
          this.$api
            .post('api/system/manage/staff/del', {
              user_id: id
            })
            .then(res => {
              this.getList()
              this.$message.success('删除成功！')
            })
        })
        .catch(() => {
          this.$message.info('已取消删除！')
        })
    },
    clearRoleInfo(done) {
      this.roleInfo = {
        role: []
      }
      done()
    },
    checkUser(checkedEmployee) {
      if (checkedEmployee === '') {
        this.isDepartmentDialog = false
        return false
      }
      if (checkedEmployee && checkedEmployee.length) {
        this.sendName = checkedEmployee[0].name
        this.sendOutName = checkedEmployee[0].id
        this.isDepartmentDialog = false
        this.$api.post('api/system/manage/staff/add', {
          user_id: this.sendOutName
        })
        .then(res => {
          const arr = res
          if (arr.length === 0) {
            this.$message.success('添加成功')
          } else {
            this.$message.error('添加失败')
          }
          this.getList()
        })
      } else {
        this.isDepartmentDialog = false
      }
    },
    addStaff() {
      this.isDepartmentDialog = true
    }
  }
}
</script>

<style lang="scss" scoped>
.tip {
    height: 80px;
    text-align:right;
    padding: 0 20px;
    background: #ffffff;
    box-shadow: 0px 2px 8px rgb(2 47 50 / 8%);
    opacity: 1;
    font-size: 14px;
    border-radius: 2px;
    margin-bottom: 20px;
    .mb20{
      position:relative;
      top:20px;
    //  left:1560px;
      float: right;
      height: 40px;
      background: #204A9E;
      opacity: 1;
      border-radius: 4px;
    }
}
::v-deep .el-button--primary{
  letter-spacing: 0;
}
::v-deep .el-checkbox{
  margin-bottom: 16px;
  padding-bottom: -26px;
}
::v-deep .el-button--primary:hover{
  background: #295FB4;
  color: #fff;
}
</style>
